/**
 * survey API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'

const prizeRequestApi = {
    // Prize Product 목록-페이징(list-paging)
    //http://52.76.231.13:8080/static/docs/prize_product.html
    prizeProductList(params, status) {
        if (status == 'request')
            return httpService.get(`/prize/product`, params)
        else
            return httpService.get(`/prize/purchase/history`)
    },

    // Prize Details 목록-페이징(list-paging)
    //http://52.76.231.13:8080/static/docs/prize_product.html
    prizeProductDetails(params) {
        return httpService.get(`/prize/product/${params}`)
    },

    prizePurchaseRequest(id, params) {
        return httpService.post(`/prize/purchase/${id}`, params)
    },

    // Prize Product 구매 내역 상세 (Detail)
    prizePurchaseDetailHistory(params) {
        return httpService.get(`/prize/purchase/history/${params}`)
    },

}

// export const 
export default prizeRequestApi